import AnalyticsObject from "../../../../src/mdx/api/schema/analytics-object.mdx";
import * as React from 'react';
export default {
  AnalyticsObject,
  React
};